(() => {
  "use strict";

  const initialized = new WeakSet();

  const SEL = {
    root: "#ig-bundle-root",
    cta: "#ig-cta",
    heroImg: ".onms-left .customSlideImg",
    heading: "#ig-heading",
    info: ".onms-info",
    cmp: ".cmp",
    now: ".now",
    save: ".save",
    includesStrong: ".includes-strong",
    bundleSelector: ".bundle-selector",
    bundleOption: ".bundle-option",
    productPrices: ".productPrices",
    subPricesWithSp: ".productPrices.subscription-prices[data-selling-id]",
    anyPricesWithSp: ".productPrices[data-selling-id]",
    formsInCta: "#ig-cta form",
    idInputsInCta: '#ig-cta input[name="id"]',
    sellingPlanHidden: 'input[name="selling_plan"]',
    submitButtonsInCta: '#ig-cta button[type="submit"], #ig-cta .product-form__submit, #ig-cta button[name="add"]',
    hideOnInit: ".productPrices, .CustomMediaUper, .CustomMedia, .orderTopHead",
    shopPayInfo: ".shop-pay-info",
    shopPayInstallment: ".shop-pay-info .installment-amount",
    priceScopes: '#ig-cta .productPrices, .order-nowMainSection .order-nowItem .productPrices',
    toggleRoot: ".purchase-toggle",
    toggleInput: '[id^="purchaseToggle-"]',
    freq: ".onms-total .frequency"
  };

  const qs = (el, sel) => (el ? el.querySelector(sel) : null);
  const qsa = (el, sel) => (el ? Array.from(el.querySelectorAll(sel)) : []);

  function waitForAny(sel, ms = 8000) {
    return new Promise((resolve) => {
      const found = Array.from(document.querySelectorAll(sel));
      if (found.length) return resolve(found);
      let done = false;
      const timeout = setTimeout(() => (done ? null : (done = true, resolve([]))), ms);
      const obs = new MutationObserver(() => {
        const all = Array.from(document.querySelectorAll(sel));
        if (all.length && !done) {
          done = true;
          clearTimeout(timeout);
          obs.disconnect();
          resolve(all);
        }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    });
  }

  function moneyTextToCents(txt) {
    if (!txt) return 0;
    const s = String(txt)
      .replace(/\s/g, "")
      .replace(/[^\d.,-]/g, "")
      .replace(/\.(?=.*\.)/g, "")
      .replace(/,(\d{2})$/, ".$1")
      .replace(/,/g, "");
    const f = parseFloat(s);
    return isFinite(f) ? Math.round(f * 100) : 0;
  }

  function setTextOrHTML(el, val) {
    if (!el) return;
    /<[^>]+>/.test(String(val)) ? (el.innerHTML = val) : (el.textContent = val);
  }

  class BundleSection {
    constructor(root) {
      this.root = root;
      this.state = { activeKey: "kit1", variantId: "", sellingPlanId: "", isSub: root.getAttribute("data-mode") === "sub" };
      this.moneyFormat = root.getAttribute("data-money-format") || "${{amount}}";
      this.country = (window.Shopify && Shopify.country) || "";
      this.routesRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

      this.$ = {
        cta: qs(root, SEL.cta),
        heroImg: qs(root, SEL.heroImg),
        heading: qs(root, SEL.heading),
        info: qs(root, SEL.info),
        cmp: qs(root, SEL.info) && qs(root, SEL.info).querySelector(SEL.cmp),
        now: qs(root, SEL.info) && qs(root, SEL.info).querySelector(SEL.now),
        save: qs(root, SEL.info) && qs(root, SEL.info).querySelector(SEL.save),
        includesStrong: qs(root, SEL.includesStrong),
        bundleSelector: qs(root, SEL.bundleSelector),
        freq: qs(root, SEL.freq),
        toggle: qs(root.parentElement || document, SEL.toggleRoot)
      };
      this.$.toggleInput = this.$.toggle && qs(this.$.toggle, SEL.toggleInput);
    }

    formatMoney(cents) {
      try {
        if (window.Shopify && typeof Shopify.formatMoney === "function") {
          return Shopify.formatMoney(cents, this.moneyFormat);
        }
      } catch (_) {}
      const suffix = this.country === "AU" ? " AUD" : this.country === "CA" ? " CAD" : "";
      return "$" + (Number(cents || 0) / 100).toFixed(2) + suffix;
    }

    formatMoneyPlain(cents) {
      const suffix = "";
      const preffix = this.country === "GB" ? "" : "$";
      return preffix + (Number(cents || 0) / 100).toFixed(2) + suffix;
    }

    readNum(key, prop) {
      return Number(this.root.getAttribute(`data-${key}-${prop}`) || 0);
    }

    readStr(key, prop) {
      return this.root.getAttribute(`data-${key}-${prop}`) || "";
    }

    readNumByMode(key, base) {
      const m = this.state.isSub ? `${base}-sub` : `${base}-ot`;
      return Number(this.root.getAttribute(`data-${key}-${m}`) || 0);
    }

    scrapePrices() {
      const scope = this.$.cta && qs(this.$.cta, SEL.productPrices);
      if (!scope) return { now: 0, cmp: 0 };
      const now = [".normalPrice [data-money]", ".normalPrice .money", ".normalPrice"]
        .map((sel) => qs(scope, sel))
        .filter(Boolean)
        .map((el) => el.getAttribute("data-money") || el.textContent)
        .map(moneyTextToCents)
        .find((v) => v > 0) || 0;
      const cmp = [".comPrice [data-money]", ".comPrice .money", ".comPrice"]
        .map((sel) => qs(scope, sel))
        .filter(Boolean)
        .map((el) => el.getAttribute("data-money") || el.textContent)
        .map(moneyTextToCents)
        .find((v) => v > 0) || 0;
      return { now, cmp };
    }

    getPrices(key) {
      let now = this.readNumByMode(key, "now");
      let cmp = Number(this.root.getAttribute(`data-${key}-cmp`) || 0);
      if (!(now > 0)) {
        const fallback = this.readNum(key, "now");
        if (fallback > 0) now = fallback;
      }
      if (!(cmp >= 0)) cmp = 0;
      if (!(now > 0) || !(cmp >= 0)) {
        const s = this.scrapePrices();
        if (s.now > 0) now = s.now;
        if (s.cmp > 0) cmp = s.cmp;
      }
      return { now: now || 0, cmp: cmp || 0 };
    }

    resolveSellingPlanForKey() {
      const hidden = qs(this.root, SEL.sellingPlanHidden);
      if (hidden?.value) return hidden.value;
      if (hidden?.dataset?.sellingPlanId) return String(hidden.dataset.sellingPlanId);
      const sub = qs(this.root, SEL.subPricesWithSp);
      if (sub?.dataset?.sellingId) return String(sub.dataset.sellingId);
      const any = qs(this.root, SEL.anyPricesWithSp);
      if (any?.dataset?.sellingId) return String(any.dataset.sellingId);
      return "";
    }

    resolveSpForMode(key) {
      if (!this.state.isSub) return "";
      return this.readStr(key, "sp") || this.resolveSellingPlanForKey(key) || "";
    }

    hideStaticBits() {
      qsa(this.root, SEL.hideOnInit).forEach((el) => {
        el.style.display = "none";
      });
    }

    syncVariantInputs(variantId) {
      qsa(this.root, SEL.idInputsInCta).forEach((input) => {
        input.value = variantId;
      });
    }

    syncSellingPlanHidden(spId) {
      const hiddenSP = qs(this.root, SEL.sellingPlanHidden);
      if (hiddenSP) hiddenSP.value = spId || hiddenSP.value || "";
    }

    updateEachPrices() {
      const keyQty = { kit1: 1, kit2: 2, kit3: 3 };
      Object.keys(keyQty).forEach((key) => {
        const qty = keyQty[key];
        let each = Number(this.root.getAttribute(`data-${key}-${this.state.isSub ? "each-sub" : "each-ot"}`) || 0);
        if (!(each > 0)) {
          const total = this.readNumByMode(key, "now") || 0;
          each = qty > 0 ? Math.round(total / qty) : 0;
        }

        const label = this.$.bundleSelector && this.$.bundleSelector.querySelector(`.bundle-option[data-key="${key}"] .priceEach`);
        if (!label) return;

        let tpl = label.getAttribute("data-tpl");
        if (!tpl) {
          const text = label.cloneNode(true).textContent.trim();
          const priceRegex = /[-+]?\$?\d[\d,]*(?:\.\d{2})?/;
          tpl = priceRegex.test(text) ? text.replace(priceRegex, "__PRICE__") : "__PRICE__ " + text;
          label.setAttribute("data-tpl", tpl);
        }

        const formatted = this.formatMoneyPlain(each);
        label.textContent = tpl.replace("__PRICE__", formatted);
      });
    }

    moneyWithSuffix(cents){
      return this.formatMoney(cents, { withSuffix:false }) + (({ AU:" AUD", CA:" CAD" })[this.country] || "");
    }

    applyKit(key) {
      this.state.activeKey = key;
      const idx = key === "kit2" ? 2 : key === "kit3" ? 3 : 1;
      const { now, cmp } = this.getPrices(key);
      const img = this.readStr(key, "img");
      const title = this.readStr(key, "heading");
      const variant = this.readStr(key, "variant");
      const spId = this.resolveSpForMode(key);

      const refillsToggle = document.querySelector(".purchase-toggle .content .item:nth-child(2)");
      if (refillsToggle && key.includes("kit1")) {
        refillsToggle.querySelector("span").textContent = "2 Refills Every 60 Days";
      }
      if (refillsToggle && key.includes("kit2")) {
        refillsToggle.querySelector("span").textContent = "4 Refills Every 60 Days";
      }
      if (refillsToggle && key.includes("kit3")) {
        refillsToggle.querySelector("span").textContent = "6 Refills Every 60 Days";
      }

      if (this.$.heroImg && img) {
        this.$.heroImg.src = img;
        this.$.heroImg.removeAttribute("srcset");
        this.$.heroImg.alt = title || "";
      }
      if (this.$.heading && title) this.$.heading.textContent = title;

      setTextOrHTML(this.$.cmp, cmp > 0 ? this.moneyWithSuffix(cmp) : "");
      setTextOrHTML(this.$.now, now > 0 ? this.moneyWithSuffix(now) : "--");

      const save = Math.max(0, (cmp || 0) - (now || 0));
      console.log(this.country);
      if (this.$.save) this.$.save.textContent = save > 0 ? `SAVE ${this.country === "GB" ? "£" : "$"}${Math.round(save / 100)}${this.country === "AU" ? " AUD" : this.country === "CA" ? " CAD" : ""}!` : "";

      if (this.$.includesStrong) {
        const kits = idx;
        this.$.includesStrong.textContent = `${kits} Kit${kits > 1 ? "s" : ""} = ${kits} Diffuser${kits > 1 ? "s" : ""} + ${kits * 2} Refills`;
      }

      if (variant) this.state.variantId = variant;
      this.syncVariantInputs(this.state.variantId);
      this.state.sellingPlanId = spId;
      this.syncSellingPlanHidden(this.state.sellingPlanId);

      if (this.$.freq) this.$.freq.style.display = this.state.isSub ? "" : "none";

      this.updateEachPrices();

      const payInfo = qs(this.root, SEL.shopPayInfo);
      const inst = qs(this.root, SEL.shopPayInstallment);
      if (payInfo) {
        if (idx >= 2) {
          payInfo.style.display = "block";
          if (inst && now) setTextOrHTML(inst, this.formatMoney(Math.round(now / 4)));
        } else {
          payInfo.style.display = "none";
        }
      }
    }

    bindBundleSelector() {
      if (!this.$.bundleSelector) return;
      this.$.bundleSelector.addEventListener("click", (e) => {
        const card = e.target.closest(SEL.bundleOption);
        if (!card) return;
        qsa(this.$.bundleSelector, SEL.bundleOption).forEach((el) => {
          const active = el === card;
          el.classList.toggle("is-active", active);
          el.setAttribute("aria-checked", active ? "true" : "false");
          const input = qs(el, 'input[type="radio"]');
          if (input) input.checked = active;
        });
        this.applyKit(card.dataset.key);
      });
    }

    async directCheckout(variantId, sellingPlanId) {
      try {
        const style = document.createElement("style");
        style.textContent = "#CartDrawer,.cart-drawer,[data-cart-drawer],.cart-notification,.ajaxified-cart-feedback{display:none!important;visibility:hidden!important}";
        document.head.appendChild(style);
        await fetch(this.routesRoot + "cart/clear.js", { method: "POST", headers: { "content-type": "application/json" }, body: "{}" });
        const body = { items: [{ id: variantId, quantity: 1, ...(sellingPlanId ? { selling_plan: sellingPlanId } : {}) }] };
        await fetch(this.routesRoot + "cart/add.js", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(body) });
        setTimeout(() => {
          window.location.assign(this.routesRoot + "checkout");
        }, "250");
      } catch (err) {
        console.warn("[IG] directCheckout error", err);
      }
    }

    bindFormsAndButtons() {
      const forms = this.getTargetForms();
      forms.forEach((form) => {
        let guard = false;
        form.addEventListener("submit", (e) => {
          const vid = this.state.variantId || qsa(this.root, SEL.idInputsInCta)[0]?.value;
          if (!vid || guard) return;
          e.preventDefault();
          guard = true;
          const sp = this.state.sellingPlanId || this.resolveSellingPlanForKey(this.state.activeKey);
          this.directCheckout(vid, sp);
        });
      });
      qsa(this.root, SEL.submitButtonsInCta).forEach((btn) => {
        btn.addEventListener("click", (e) => {
          const vid = this.state.variantId || qsa(this.root, SEL.idInputsInCta)[0]?.value;
          if (!vid) return;
          e.preventDefault();
          const sp = this.state.sellingPlanId || this.resolveSellingPlanForKey(this.state.activeKey);
          this.directCheckout(vid, sp);
        });
      });
    }

    getTargetForms() {
      const forms = qsa(this.root, SEL.formsInCta);
      const precise = forms.find((f) => f.classList.contains("form") && f.dataset.type === "add-to-cart-form");
      if (precise) return [precise];
      return forms.length ? [forms[forms.length - 1]] : [];
    }

    observePriceZones() {
      const scopes = qsa(this.root, SEL.priceScopes);
      if (!scopes.length) {
        this.applyKit("kit1");
        return;
      }
      let scheduled = false;
      const stopAt = Date.now() + 4000;
      const mo = new MutationObserver(() => {
        if (Date.now() > stopAt) {
          mo.disconnect();
          return;
        }
        if (scheduled) return;
        scheduled = true;
        setTimeout(() => {
          scheduled = false;
          const active = (qs(this.root, ".bundle-option.is-active") || { dataset: { key: "kit1" } }).dataset.key || "kit1";
          this.applyKit(active);
        }, 60);
      });
      scopes.forEach((sc) => mo.observe(sc, { childList: true, subtree: true, characterData: true }));
      this.applyKit("kit1");
    }

    bindToggle() {
      if (!this.$.toggleInput) return;
      this.$.toggleInput.checked = this.state.isSub;
      this.$.toggleInput.addEventListener("change", () => {
        this.state.isSub = this.$.toggleInput.checked;
        this.root.setAttribute("data-mode", this.state.isSub ? "sub" : "ot");
        this.applyKit(this.state.activeKey);
        this.updateEachPrices();
      });
    }

    init() {
      if (initialized.has(this.root)) return;
      initialized.add(this.root);
      this.hideStaticBits();
      this.bindBundleSelector();
      this.bindToggle();
      this.observePriceZones();
      this.bindFormsAndButtons();
    }
  }

  function boot() {
    waitForAny(SEL.root, 8000).then((roots) => {
      roots.forEach((root) => new BundleSection(root).init());
    });
    const docObserver = new MutationObserver((muts) => {
      muts.forEach((m) => {
        Array.from(m.addedNodes).forEach((n) => {
          if (!(n instanceof Element)) return;
          if (n.matches && n.matches(SEL.root)) new BundleSection(n).init();
          n.querySelectorAll && n.querySelectorAll(SEL.root).forEach((r) => new BundleSection(r).init());
        });
      });
    });
    docObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);

  const $$=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const scopeOf = el => el.closest('.onms-inner') || document.querySelector('.onms-inner') || document.body;
  const setMode = (sc, on)=>{ sc.classList.toggle('mode-subscribe', on); sc.classList.toggle('mode-one-time', !on); };
  const initToggle = inp => { if (inp._inited) return; inp._inited=1; setMode(scopeOf(inp), inp.checked); inp.addEventListener('change',e=>setMode(scopeOf(e.currentTarget), e.currentTarget.checked)); };

  const handleKit = t => { const sc=scopeOf(t); const k=t.getAttribute('data-key'); sc.classList.toggle('over40', k==='kit2' || k==='kit3'); };

  const ready = cb => document.readyState!=='loading' ? cb() : document.addEventListener('DOMContentLoaded', cb);

  ready(()=>{
    $$('.toggle__input').forEach(initToggle);
    document.addEventListener('click', e=>{ const t=e.target.closest('[data-key]'); if (t) handleKit(t); });
    new MutationObserver(ms=>ms.forEach(m=>$$('.toggle__input', m.target).forEach(initToggle))).observe(document.documentElement,{subtree:true,childList:true});
  });
})();
